export const FIRST_DAY_OF_WEEK_VALUES = [1, 6, 7];
/**
 * @deprecated appVer 5.3.15
 * TODO: Remove this and just use ActivationChannel enum instead as right now they are tightly coupled and require the same values
 * to exist in both enums or the world blows up (just kidding, you just get red builds in NCBackend3 due to joi schemas).
 */
export var AppId = /*#__PURE__*/function (AppId) {
  AppId[AppId["NC"] = 1] = "NC";
  AppId[AppId["CLEARBLUE"] = 2] = "CLEARBLUE";
  AppId[AppId["RETAIL"] = 3] = "RETAIL";
  AppId[AppId["OURA"] = 4] = "OURA";
  return AppId;
}(AppId || {});
/**
 * Describes the channel through which a user purchased their subscription. Currently
 * this is determined purely from the discount code used during purchase.
 *
 * ActivationChannel.NC is the default channel when no other channel is specified.
 */
export var ActivationChannel = /*#__PURE__*/function (ActivationChannel) {
  ActivationChannel[ActivationChannel["NC"] = 1] = "NC";
  ActivationChannel[ActivationChannel["CLEARBLUE"] = 2] = "CLEARBLUE";
  ActivationChannel[ActivationChannel["RETAIL"] = 3] = "RETAIL";
  ActivationChannel[ActivationChannel["OURA"] = 4] = "OURA";
  return ActivationChannel;
}(ActivationChannel || {});
export var CyclerStatus = /*#__PURE__*/function (CyclerStatus) {
  CyclerStatus[CyclerStatus["newbie"] = 1] = "newbie";
  CyclerStatus[CyclerStatus["junior"] = 2] = "junior";
  CyclerStatus[CyclerStatus["skilled"] = 3] = "skilled";
  CyclerStatus[CyclerStatus["pro"] = 4] = "pro";
  CyclerStatus[CyclerStatus["star"] = 5] = "star";
  return CyclerStatus;
}(CyclerStatus || {});
export var SupportTicketCategory = /*#__PURE__*/function (SupportTicketCategory) {
  SupportTicketCategory[SupportTicketCategory["ACCOUNT"] = 1] = "ACCOUNT";
  SupportTicketCategory[SupportTicketCategory["DELIVERY"] = 2] = "DELIVERY";
  SupportTicketCategory[SupportTicketCategory["THERMOMETER"] = 3] = "THERMOMETER";
  SupportTicketCategory[SupportTicketCategory["APP"] = 4] = "APP";
  SupportTicketCategory[SupportTicketCategory["TECHNICAL"] = 5] = "TECHNICAL";
  SupportTicketCategory[SupportTicketCategory["FEEDBACK"] = 6] = "FEEDBACK";
  SupportTicketCategory[SupportTicketCategory["OTHER"] = 7] = "OTHER";
  SupportTicketCategory[SupportTicketCategory["INSURANCE"] = 8] = "INSURANCE";
  return SupportTicketCategory;
}(SupportTicketCategory || {});